<template>
  <el-select
      v-model="selectedCutoffExempt"
      @input="emitInput()"
      @change="emitChange()"
      ref="cutoff-exempt-select"
  >
    <el-option
        v-for="cutoffExempt in cutoffExempts"
        :key="cutoffExempt.value"
        :label="cutoffExempt.label"
        :value="cutoffExempt.value"
    ></el-option>
  </el-select>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'ShipperCutoffExempt',
  props: ['value', 'includeOptionAll'],
  watch: {
    value(newValue) {
      this.selectedCutoffExempt = newValue;
    },
  },
  data() {
    return {
      selectedCutoffExempt: this.value,
      cutoffExempts: [],
    };
  },
  mounted() {
    if (this.includeOptionAll) {
      this.cutoffExempts.push({
        value: null,
        label: this.$t('common.all')
      });
    }

    this.cutoffExempts.push(
      constants.STATUS_BOOLEAN.yes,
      constants.STATUS_BOOLEAN.no
    );
  },
  methods: {
    emitInput() {
      this.$emit('update:value', this.selectedCutoffExempt);
      this.$emit('input', this.selectedCutoffExempt);
    },
    emitChange() {
      this.$emit('update:value', this.selectedCutoffExempt);
      this.$emit('change', this.selectedCutoffExempt);
    },
    setSelectedShipperCutoffExempt(selected) {
      this.selectedCutoffExempt = selected;
    },
  },
};
</script>
